import { useEffect } from "react";

/**
 * "Start a new one of these", asked from anywhere.
 *
 * The New button in the top bar and the search box both offer to start a
 * letter, a task, a message. The dialog that does it belongs to a screen,
 * and the screen may not be the one that is open. So the asker leaves a
 * note here and goes to the screen; the screen picks the note up when it
 * arrives — or straight away, if it was already there — and opens its own
 * dialog. One note at a time: the last thing asked for is the thing wanted.
 */
let wanted: string | null = null;
const waiting = new Set<() => void>();

export function askToCreate(kind: string) {
  wanted = kind;
  for (const check of [...waiting]) check();
}

/** Opens this screen's dialog when somebody has asked for one of `kind`. */
export function useCreateRequest(kind: string, open: () => void) {
  useEffect(() => {
    function check() {
      if (wanted !== kind) return;
      wanted = null;
      open();
    }
    // After the screen has painted, not during the effect itself.
    const soon = window.setTimeout(check, 0);
    waiting.add(check);
    return () => {
      window.clearTimeout(soon);
      waiting.delete(check);
    };
  }, [kind, open]);
}
